<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.billStatus === 'Y'
              ? 'success'
              : row.billStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.billStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.stockInCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            v-show="row.billStatus === 'N'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.stockInCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            v-show="row.billStatus === 'N'"
            placement="top"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.stockInCode)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('C')"
            v-show="row.billStatus === 'N'"
          >
            <i
              class="el-icon-check tool-btn"
              @click="audit(row.stockInCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="打印"
            placement="top"
            v-if="allow('P')"
            v-show="row.billStatus === 'Y'"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="print(row.stockInCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{$l('INDEX.table_label_no_data ') || '暂无数据！',}}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 140,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('INDEX.form_label_bill_no') || '单据编号',
          field: 'stockInNo',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.bill_in_date') || '入库日期',
          field: 'inDate',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.Status') || '单据状态',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          slots: { default: 'status' },
        },
        {
          headerAlign: 'center',
          field: 'createByName',
          title: this.$l('INDEX.creator') || '创建人',
          minWidth: 120,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          headerAlign: 'center',
          field: 'createDate',
          title: this.$l('INDEX.bill_time_create_time') || '创建时间',
          align: 'center',
          minWidth: 170,
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          headerAlign: 'center',
          field: 'modifyByName',
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          minWidth: 120,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          headerAlign: 'center',
          field: 'modifyDate',
          title: this.$l('INDEX.bill_time_modify_time') || '修改时间',
          minWidth: 170,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
      ],
    }
  },
  methods: {
    del(stockInCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .sampleStockInLDelApi({ stockInCode })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    audit(code) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .sampleStockInAuditApi({
            stockInCode: code,
          })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'samplemanage-sampletockIn-detail',
        params: { ...params, pageType },
      })
    },

    print(stockInCode) {
      let data = { stockInCode }
      let fileName = '入库样品标签'
      this.$api.globalExportData(
        '/samplemanage/billStockInMain/print',
        data,
        fileName
      )
    },
  },
}
</script>
